import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { QuickActionsNav } from '@/components/quick-actions-nav';
import { UsersTable, columns } from '@/features/users/components/users-table/users-table.tsx';
import { useGetUsersQuery } from '@/features/users/hooks/queries/get-all-users.tsx';

const Users = () => {
  const { data: users, isLoading } = useGetUsersQuery();

  return (
    <div className="w-full gap-2 px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Users</h1>

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <UsersTable data={users || []} columns={columns} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default Users;
